export const checkboxWrapper =
  'flex w-full flex-row justify-start items-center';
export const label = 'font-medium block text-base font-body text-textMid';
